import { render } from "./Meditsina.vue?vue&type=template&id=5e00fb5d"
import script from "./Meditsina.vue?vue&type=script&lang=js"
export * from "./Meditsina.vue?vue&type=script&lang=js"

import "./Meditsina.vue?vue&type=style&index=0&id=5e00fb5d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__